import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';
import './swiper.css';

(function(Drupal, once, Swiper) {
  function setRunning(el, swiper) {

      el.classList.remove('running');

  }

  const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

  Drupal.behaviors.swiper = {

    attach(context) {
      once('swiper-init', '.swiper', context)
        .forEach(el => {
          const config = {
            modules: [Navigation, Pagination, Scrollbar, Autoplay],
            loop: false,
            autoplay: false,
            keyboard: true,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            grabCursor: true,
          };

            config.slidesPerView = "auto";
            config.spaceBetween = 30;

          const mySlider = new Swiper(el, config);

          // Prefers Reduced Motion browser flag check
          // if (!!isReduced) {
          //   mySlider.autoplay.stop();
          // }

          // mySlider.on('autoplayPause', (swiper) => {
          //   setRunning(el, swiper);
          // });
          // mySlider.on('autoplayResume', (swiper) => {
          //   setRunning(el, swiper);
          // });

          el.style.setProperty('--swiper-pagination-bullet-width', `calc(80% / ${mySlider.slides.length}`)
          if (!mySlider.slides.length) {
            el.classList.add('hide-all');
          }
          // el.style.setProperty('--swiper-count', mySlider.slides.length);
          const playBtn = el.querySelector('.play-btn');
          playBtn.addEventListener('click', () => {
            mySlider.autoplay.start();
            setRunning(el, mySlider);
          });
          const pauseBtn = el.querySelector('.pause-btn');
          pauseBtn.addEventListener('click', () => {
            mySlider.autoplay.stop();
            setRunning(el, mySlider);
          });

          setRunning(el, mySlider);
        });
    },
  };

})(Drupal, once, Swiper);
